// extracted by mini-css-extract-plugin
export default {"itemViewFeedContainer":"AssessmentLibrary__itemViewFeedContainer___wTX_X","itemViewFeedContainerRevamp":"AssessmentLibrary__itemViewFeedContainerRevamp___sZ3ug"};